import { render, staticRenderFns } from "./Thema.vue?vue&type=template&id=490c3944&scoped=true&"
import script from "./Thema.vue?vue&type=script&lang=js&"
export * from "./Thema.vue?vue&type=script&lang=js&"
import style0 from "./Thema.vue?vue&type=style&index=0&id=490c3944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490c3944",
  null
  
)

export default component.exports